const styles = {
    container: {
        color: 'rgba(26,26,26,.9)',
        marginTop: 50
    },
    servicesHeaderMain: {
        color: 'rgb(61, 153, 145)'
    },
    servicesHeader: {
        marginTop: 0,
        color: 'rgb(61, 153, 145)'
    },
    servicesLink: {
        display: 'block',
        color: 'rgba(26,26,26,.9)',
        cursor: 'pointer',
        textDecoration: 'none',
        marginBottom: 10
    },
    executiveDiv: {
        marginTop: 50
    },
    serviceList: {
        marginBottom: 3
    },
    serviceDetailLinkDiv: {
        marginBottom: 30
    },
    serviceDetailLink: {
        textDecoration: 'none',
        color: 'rgb(61, 153, 145)',
        fontWeight: 600
    }
};

export default styles;


// WEBPACK FOOTER //
// ./src/containers/Services/ServicesStyle.js